import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import { useOutletContext } from "react-router-dom";

const InvoiceStatusCell = ({ role_id }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const [state, setState] = useState(null);

  useEffect(() => {
    const checkInvoice = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/invoices/checkInvoice/${role_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setState(response.data.raise_invoice.join(" ") || []);
      } catch (error) {
        console.log(error);
        setState("Error");
      }
    };

    checkInvoice();
  }, [role_id]);

  return <span dangerouslySetInnerHTML={{ __html: state }} />;
};

export default InvoiceStatusCell;
